import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BrandProvider } from './context/BrandContext';
import { AuthCallback } from './components/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';
import Dashboard from './pages/Dashboard';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Library from './pages/Library';
import Create from './pages/Create';
import Editor from './pages/Editor';
import AIAssistant from './pages/AIAssistant';
import Admin from './pages/Admin';
import PolicySummarizer from './pages/PolicySummarizer';
import Competency from './pages/tools/Competency';
import Attestation from './pages/tools/Attestation';
import Consent from './pages/tools/Consent';
import DoorSign from './pages/tools/DoorSign';
import SBAR from './pages/tools/SBAR';
import QRGenerator from './pages/tools/QRGenerator';
import Certificate from './pages/tools/Certificate';
import Orientation from './pages/tools/Orientation';
import ReturnDemo from './pages/tools/ReturnDemo';
import Huddle from './pages/tools/Huddle';
import TentCard from './pages/tools/TentCard';
import SafetyDisplay from './pages/tools/SafetyDisplay';
import BadgeBuddy from './pages/tools/BadgeBuddy';
import A3 from './pages/tools/A3';
import RCA from './pages/tools/RCA';
import ActionPlan from './pages/tools/ActionPlan';
import Audit from './pages/tools/Audit';
import SmartSheet from './pages/tools/SmartSheet';
import TestGenerator from './pages/tools/TestGenerator';
import BulkPrint from './pages/tools/BulkPrint';
import { ProcessGuide, ClinicalAlgorithm } from './pages/tools/AITools';
import PosterStudio from './pages/PosterStudio';
import ToolPlaceholder from './pages/ToolPlaceholder';

const builtTools = [
  { path: '/tools/competency', el: <Competency /> },
  { path: '/tools/attestation', el: <Attestation /> },
  { path: '/tools/consent', el: <Consent /> },
  { path: '/tools/door-sign', el: <DoorSign /> },
  { path: '/tools/sbar', el: <SBAR /> },
  { path: '/tools/qr-generator', el: <QRGenerator /> },
  { path: '/tools/certificate', el: <Certificate /> },
  { path: '/tools/orientation', el: <Orientation /> },
  { path: '/tools/return-demo', el: <ReturnDemo /> },
  { path: '/tools/huddle', el: <Huddle /> },
  { path: '/tools/tent-card', el: <TentCard /> },
  { path: '/tools/safety-display', el: <SafetyDisplay /> },
  { path: '/tools/badge-buddy', el: <BadgeBuddy /> },
  { path: '/tools/a3', el: <A3 /> },
  { path: '/tools/rca', el: <RCA /> },
  { path: '/tools/action-plan', el: <ActionPlan /> },
  { path: '/tools/audit', el: <Audit /> },
  { path: '/tools/smartsheet', el: <SmartSheet /> },
  { path: '/tools/test-generator', el: <TestGenerator /> },
  { path: '/tools/bulk-print', el: <BulkPrint /> },
  { path: '/tools/poster', el: <PosterStudio /> },
  { path: '/tools/process-guide', el: <ProcessGuide /> },
  { path: '/tools/clinical-algorithm', el: <ClinicalAlgorithm /> },
];

const tools = [];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
      <Route path="/create" element={<ProtectedRoute><Create /></ProtectedRoute>} />
      <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
      <Route path="/ai-assistant" element={<ProtectedRoute><AIAssistant /></ProtectedRoute>} />
      <Route path="/tools/policy-summarizer" element={<ProtectedRoute><PolicySummarizer /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
      {builtTools.map((t) => (
        <Route key={t.path} path={t.path} element={<ProtectedRoute>{t.el}</ProtectedRoute>} />
      ))}
      {tools.map((t) => (
        <Route
          key={t.path}
          path={t.path}
          element={<ProtectedRoute><ToolPlaceholder title={t.title} description="This tool is coming in an upcoming build phase." /></ProtectedRoute>}
        />
      ))}
    </Routes>
  );
}

function App() {
  useEffect(() => { document.documentElement.classList.add('dark'); }, []);
  return (
    <div className="App min-h-screen text-slate-100" style={{ background: '#080c14', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <AuthProvider>
        <BrandProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster />
        </BrandProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
